<icon-component
  [iconName]="iconName"
  [toolTipText]="tooltip"
  [toolTipClass]="tooltipClass"
  [noSdxIcon]="noSdxIcon"
  [cssClass]="cssClass"
  [disabled]="disabled"
  [hidden]="hidden"
></icon-component>
